import store from "@/store/store";

export const requiresAdminMixin = {
  beforeRouteEnter(to, from, next) {
    if (!store.state.auth.roles) {
      next({ name: "Home" });
      return;
    }

    if (store.state.auth.roles.includes("Admin")) {
      next();
      return;
    }

    next({ name: "Home" });
  }
};
